module.exports = __webpack_public_path__ + "img/长沙理工.3ca72fab.png";